var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-pagination"},[_c('BasePagination',{attrs:{"debug":_vm.debug,"value":_vm.current,"count":_vm.count,"page-size":_vm.perPage},on:{"pageChange":_vm.pageChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }